export default __webpack_public_path__ + "static/media/banner-module0-test.ac15dbbd.png";